import React from "react";
import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
  Intent,
  Checkbox,
  Callout
} from "@blueprintjs/core";
import FormInfo from "../../atoms/FormInfo/FormInfo";
import { useHistory } from "react-router-dom";

function TopOffDialog({
  isTopOffDialogOpen,
  setIsTopOffDialogOpen,
  topOffAmount,
  setTopOffAmount,
  isTopOffConfirmed,
  setIsTopOffConfirmed,
  topOffDescription,
  setTopOffDescription,
  cashOurError,
  bank
}) {
  const history = useHistory();

  function closeDialog() {
    setIsTopOffDialogOpen(false);
  }
  return (
    <Dialog
      icon="dollar"
      canOutsideClickClose={false}
      onClose={closeDialog}
      title="Top Off"
      isOpen={isTopOffDialogOpen}
    >
      {cashOurError && (
        <Callout
          icon="error"
          intent={Intent.DANGER}
          title={"Top Off Transaction failed."}
        >
          {cashOurError}
        </Callout>
      )}
      <form>
        <div className={Classes.DIALOG_BODY}>
          <FormInfo>
            Vestibulum rutrum quam vitae fringilla tincidunt. Suspendisse nec
            tortor urna. Ut laoreet sodales nisi,.
          </FormInfo>
          <FormGroup label="Top Off Amount" labelFor="TopOffAmount">
            <InputGroup
              id="TopOffAmount"
              type="text"
              autoCapitalize="none"
              placeholder={"$0.00"}
              autoCorrect="false"
              value={topOffAmount}
              onChange={setTopOffAmount}
            />
          </FormGroup>
          <FormGroup label="Top Off from this Account">
            <InputGroup
              value={bank.digits ? `Account Ending ${bank.digits}` : "NA"}
              disabled
              rightElement={
                <Button
                  text="Change"
                  onClick={() => history.push("/settings/bank-account")}
                />
              }
            />
          </FormGroup>
          <FormGroup label="Description (optional)" labelFor={"TopOffDesc"}>
            <InputGroup
              id="TopOffDesc"
              type="text"
              placeholder={"ex. refund, campaign, influencer…"}
              autoCapitalize="none"
              autoCorrect="false"
              value={topOffDescription}
              onChange={setTopOffDescription}
            />
          </FormGroup>
          <FormGroup label="Confirm Top-Off" labelFor={"confirm"}>
            <Checkbox
              checked={isTopOffConfirmed}
              onChange={setIsTopOffConfirmed}
              label={
                "$150.00 will be added immediately to your Video Squirrel account."
              }
              id="confirm"
            />
          </FormGroup>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={closeDialog} type="button" minimal>
              Cancel
            </Button>
            <Button onClick={() => {}} type="button" intent={Intent.PRIMARY}>
              Next
            </Button>
          </div>
        </div>
      </form>
    </Dialog>
  );
}

export default TopOffDialog;
